// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { Component } from './component';

/**
 * @class Jsw.StatusMessage
 * @extends Jsw.Component
 */
export const StatusMessage = Class.create(Component, {
    _initConfiguration($super, config) {
        config = Object.extend({
            renderTo: 'main',
            renderMode: 'top',
        }, config || {});
        $super(config);
        this._type = this._getConfigParam('type', 'error');
        this._cls = this._getConfigParam('cls', `msg-box msg-${this._type}`);
        this._title = this._getConfigParam('title', '');
        this._message = this._getConfigParam('message', '');
        this._closable = this._getConfigParam('closable', false);
        this._onClose = this._getConfigParam('onClose', null);
    },

    _initComponentElement($super) {
        $super();

        const content = this._renderCloseButton() + this._renderMessage();
        this._updateComponentElement(
            '<div><div><div><div><div>' +
            `<div class="msg-content">${content}</div>` +
            '</div></div></div></div></div>'
        );
    },

    _renderMessage() {
        let message = '';
        if (this._title) {
            message = `<b>${this._title}:</b> `;
        }
        message += this._message;
        return message;
    },

    _renderCloseButton() {
        if (!this._closable) {
            return '';
        }
        return '<span class="close"></span>';
    },

    _addEvents($super) {
        $super();

        this._componentElement.select('.close').each(function (closeButton) {
            Event.observe(closeButton, 'click', this._onCloseEvent.bind(this));
        }, this);
    },

    _onCloseEvent() {
        if (!this._onClose) {
            return;
        }
        this._onClose();
    },
});



// WEBPACK FOOTER //
// ./jsw/status-message.js